import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

// Loads an access-controlled image (e.g. /student-photo/:id) with the auth header,
// since a plain <img src> cannot send a Bearer token.
export default function AuthImage({ path, alt = "", className = "", fallback = null }) {
  const [url, setUrl] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let revoked = false;
    let objUrl = null;
    if (!path) { setState("error"); return; }
    setState("loading");
    api.get(path, { responseType: "blob" })
      .then((res) => {
        if (revoked) return;
        objUrl = URL.createObjectURL(res.data);
        setUrl(objUrl); setState("ok");
      })
      .catch(() => { if (!revoked) setState("error"); });
    return () => { revoked = true; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);

  if (state === "loading") return <div className={`flex items-center justify-center bg-slate-100 ${className}`}><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>;
  if (state === "error") return fallback || <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`}><ImageOff className="h-6 w-6" /></div>;
  return <img src={url} alt={alt} className={className} />;
}
